import React, { useState } from 'react';
import { Container, Row, Col, Card, Button, Alert } from 'react-bootstrap';
import { Package, ArrowUp, ArrowDown, ClipboardList } from 'lucide-react';
import ProductList from '../components/products/ProductList';
import StockMovementList from '../components/stock/StockMovementList';
import StockAdjustmentForm from '../components/stock/StockAdjustmentForm';
import useAuth from '../hooks/useAuth';

const InventoryManagement = () => {
    const { isAdmin, isManager, isWarehouseManager } = useAuth();
    const [view, setView] = useState('overview');
    const [error, setError] = useState('');

    const canManageStock = isAdmin || isManager || isWarehouseManager;

    if (!canManageStock) {
        return (
            <Container>
                <div className="alert alert-danger mt-4">
                    Vous n'êtes pas autorisé à accéder à cette page.
                </div>
            </Container>
        );
    }

    const handleAddMovement = () => {
        setView('adjust');
    };

    const handleViewProducts = () => {
        setView('products');
    };

    const handleViewMovements = () => {
        setView('movements');
    };

    const handleGoBack = () => {
        setView('overview');
    };

    const handleSuccess = () => {
        setView('movements');
    };

    return (
        <Container fluid>
            <div className="d-flex justify-content-between align-items-center mb-4">
                <h1 className="h3">Gestion des stocks</h1>
            </div>

            {error && <Alert variant="danger">{error}</Alert>}

            {view === 'overview' && (
                <Row>
                    <Col md={4} className="mb-4">
                        <Card className="h-100 shadow-sm">
                            <Card.Body className="d-flex flex-column">
                                <div className="text-center mb-4">
                                    <Package size={48} className="text-primary mb-3" />
                                    <h5>Produits</h5>
                                    <p className="text-muted">Gérer les produits et consulter les niveaux de stock</p>
                                </div>
                                <Button
                                    variant="primary"
                                    onClick={handleViewProducts}
                                    className="mt-auto"
                                >
                                    Voir produits
                                </Button>
                            </Card.Body>
                        </Card>
                    </Col>

                    <Col md={4} className="mb-4">
                        <Card className="h-100 shadow-sm">
                            <Card.Body className="d-flex flex-column">
                                <div className="text-center mb-4">
                                    <div className="d-flex justify-content-center mb-3">
                                        <ArrowUp size={24} className="text-success me-2" />
                                        <ArrowDown size={24} className="text-danger" />
                                    </div>
                                    <h5>Mouvements de stock</h5>
                                    <p className="text-muted">Voir l'historique des mouvements de stock et les transactions
                                    </p>
                                </div>
                                <Button
                                    variant="primary"
                                    onClick={handleViewMovements}
                                    className="mt-auto"
                                >
                                    Voir les mouvements
                                </Button>
                            </Card.Body>
                        </Card>
                    </Col>

                    <Col md={4} className="mb-4">
                        <Card className="h-100 shadow-sm">
                            <Card.Body className="d-flex flex-column">
                                <div className="text-center mb-4">
                                    <ClipboardList size={48} className="text-warning mb-3" />
                                    <h5>Ajustment de stock</h5>
                                    <p className="text-muted">Ajuster les niveaux de stock et enregistrer les mouvements
                                    </p>
                                </div>
                                <Button
                                    variant="warning"
                                    onClick={handleAddMovement}
                                    className="mt-auto"
                                >
                                    Ajuster le stock
                                </Button>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            )}

            {view === 'products' && (
                <>
                    <Button
                        variant="outline-secondary"
                        onClick={handleGoBack}
                        className="mb-3"
                    >
                        Retour à l’aperçu
                    </Button>
                    <ProductList
                        onViewProduct={() => { }}
                        onAddProduct={() => { }}
                        onEditProduct={() => { }}
                    />
                </>
            )}

            {view === 'movements' && (
                <>
                    <Button
                        variant="outline-secondary"
                        onClick={handleGoBack}
                        className="mb-3"
                    >
                        Retour à l’aperçu
                    </Button>
                    <StockMovementList
                        onAddMovement={handleAddMovement}
                    />
                </>
            )}

            {view === 'adjust' && (
                <>
                    <Button
                        variant="outline-secondary"
                        onClick={handleGoBack}
                        className="mb-3"
                    >
                       Retour à l’aperçu
                    </Button>
                    <StockAdjustmentForm
                        onCancel={handleSuccess}
                        onSuccess={handleSuccess}
                    />
                </>
            )}
        </Container>
    );
};

export default InventoryManagement;